// Helper to convert a Google Maps Path to a WKT string
export const toWkt = (shape, type) => {
    const path = shape?.getPath?.()?.getArray?.() ?? [];
    if (path.length === 0 && type !== 'CIRCLE') return '';

    let wkt = path.map((latLng) => `${latLng.lat()} ${latLng.lng()}`).join(', ');

    if (type === 'POLYGON' && path.length > 2) {
        // A valid polygon in WKT must be closed (first and last points are the same)
        const firstPoint = `${path[0].lat()} ${path[0].lng()}`;
        if (wkt.slice(-firstPoint.length) !== firstPoint) {
            wkt += `, ${firstPoint}`;
        }
        return `POLYGON((${wkt}))`;
    }
    if (type === 'LINESTRING') {
        return `LINESTRING(${wkt})`;
    }
    // This can be extended for Circles by calculating points on the circumference
    if (type === 'CIRCLE') {
        const center = shape.getCenter();
        const radius = shape.getRadius(); // in meters

        const lat = center.lat();
        const lng = center.lng();

        return `CIRCLE(${lat} ${lng}, ${radius})`;
    }
    // if (type === 'CIRCLE') {
    //     // Traccar Web UI approximation for a circle is a 40-point polygon
    //     const center = shape.getCenter();
    //     const radius = shape.getRadius(); // in meters
    //     const R = 6371e3; // Earth's radius in meters
    //     const lat = (center.lat() * Math.PI) / 180;
    //     const lon = (center.lng() * Math.PI) / 180;
    //     const d = radius / R;
    //     let circleWkt = '';
    //     for (let i = 0; i <= 40; i += 1) {
    //         const brng = (i * (360 / 40) * Math.PI) / 180;
    //         let pLat = Math.asin(
    //             Math.sin(lat) * Math.cos(d) + Math.cos(lat) * Math.sin(d) * Math.cos(brng),
    //         );
    //         let pLon = lon
    //             + Math.atan2(
    //                 Math.sin(brng) * Math.sin(d) * Math.cos(lat),
    //                 Math.cos(d) - Math.sin(lat) * Math.sin(pLat),
    //             );
    //         pLat = (pLat * 180) / Math.PI;
    //         pLon = (pLon * 180) / Math.PI;
    //         circleWkt += `${pLon} ${pLat},`;
    //     }
    //     return `POLYGON((${circleWkt.slice(0, -1)}))`;
    // }
    return '';
};

// Helper to convert a WKT string to an array of Google Maps LatLng objects or circle data
export const fromWkt = (googleMapsApi, wkt) => {
    if (!wkt || !googleMapsApi) {
        return { type: null, path: [] };
    }

    const wktTypeMatch = wkt.match(/^(\w+)/);
    const type = wktTypeMatch ? wktTypeMatch[1].toUpperCase() : null;

    if (type === 'CIRCLE') {
        const coords = wkt.match(/-?\d+\.?\d*/g);
        return {
            type,
            center: new googleMapsApi.LatLng(parseFloat(coords[1]), parseFloat(coords[0])),
            radius: parseFloat(coords[2]),
        };
    }

    const coordinateMatches = wkt.match(/-?\d+\.?\d*\s-?\d+\.?\d*/g);
    if (!coordinateMatches) {
        return { type, path: [] };
    }

    const path = coordinateMatches.map((pair) => {
        const [lng, lat] = pair.split(/\s+/).map(Number);
        return new googleMapsApi.LatLng(lat, lng);
    });

    return { type, path };
};